// extracted by mini-css-extract-plugin
module.exports = {"headOfficePhoneNumber":"HeadOfficePhoneNumber_headOfficePhoneNumber__lmm1D","headOfficePhoneNumberWhite":"HeadOfficePhoneNumber_headOfficePhoneNumberWhite__vjv3k"};